import * as actionTypes from "../actionTypes";
import Messages from "../../../helper/messages";
import ReactHtmlParser from "react-html-parser";
import { store } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';
import * as ImmersionGQL from "../../../gql";

// experience List Success
export const initExpParticipantData = () => ({
  type: actionTypes.INITI_EXP_PARTICIPANT_DATA,
});

// experience List Success
const experienceListSuccess = (items: any, userId: any) => ({
  type: actionTypes.EXPERIENCE_GET_LIST_SUCCESS,
  payload: {items, userId},
});

//refresh thumbnails of experience list
const checkStimulusStatusSuccess = (stimulusitem: any, userId: any) => ({
  type: actionTypes.CHECK_STIMULUS_STATUS_SUCCESS,
  payload: {stimulusitem, userId},
});

// reels child List Success
const reelsSessionsListSuccess = (items: any, userId: any) => ({
  type: actionTypes.REELS_SESSIONS_LIST_SUCCESS,
  payload: {items, userId},
});

// reels Add Success
const reelsAddSuccess = (item: any) => ({
  type: actionTypes.REELS_ADD_SUCCESS,
  payload: item,
});

//get sessions of the reels
const reelSessionsList = (item: any) => ({
  type: actionTypes.GET_ONLY_REELS_SESSIONS_SUCCESS,
  payload: item,
});

// reels main experience List Success
const listExperienceReelsSuccess = (reelsitems: any, userId: any) => ({
  type: actionTypes.GET_LIST_EXPERIENCE_REELS_SUCCESS,
  payload: {reelsitems, userId},
});

// add or remove expeirnce from project folder
const addProjectToExperienceSuccess = (res: any) => ({
  type: actionTypes.ADD_PROJECT_TO_EXPERIENCE_SUCCESS,
  payload: res
});

// project experience List Success
const projectExperienceListSuccess = (projectitems: any, userId: any) => ({
  type: actionTypes.GET_PROJECT_EXPERIENCE,
  payload: {projectitems, userId},
});

// merge clips experience List Success
const mergeClipsSuccess = (clipitems: any) => ({
  type: actionTypes.GET_MERGE_CLIPS,
  payload: clipitems
});

// experience Add Success
const experienceAddSuccess = (item: any) => ({
  type: actionTypes.EXPERIENCE_ADD_SUCCESS,
  payload: item,
});

// experience Add Success
const experienceEditSuccess = (item: any) => ({
  type: actionTypes.EXPERIENCE_EDIT_SUCCESS,
  payload: item,
});

// experience Cancel Success
const experienceCancelSuccess = (item: any) => ({
  type: actionTypes.EXPERIENCE_CANCEL_SUCCESS,
  payload: item,
});

// experience Add Success
export const singleExperience = (item: any) => ({
  type: actionTypes.EXPERIENCE_SAVE_SINGLE,
  payload: item,
});

// experience Add Success
export const setLoading = (value: any) => ({
  type: actionTypes.SET_EXPERIENCE_LOADING,
  payload: value,
});

export const setBenchmarkLoading = (value: any) => ({
  type: actionTypes.SET_BENCHMARK_LOADING,
  payload: value
});

// experience Add Success
export const setSearchLoading = (value: any) => ({
  type: actionTypes.SET_EXPERIENCE_SEARCH_LOADING,
  payload: value,
});

export const emptyExperience = () => ({
  type: actionTypes.EXPERIENCE_EMPTY,
});

export const updateStimulus = (res: any) => ({
  type: actionTypes.UPDATE_STIMULUS,
  payload: res,
});

export const updateSearchText = (res: any) => ({
  type: actionTypes.UPDATE_SEARCHTEXT,
  payload: res,
});

export const onClearSearch = (clear: boolean) => ({
  type: actionTypes.CLEAR_SEARCH,
  payload: clear
});

export const updatesearchfilters = (res: any) => ({
  type: actionTypes.UPDATE_SEARCHFILTERS,
  payload: res,
});

export const updateSearchUsers = (res: any) => ({
  type: actionTypes.UPDATE_SEARCHUSERS,
  payload: res,
});

export const updateSearchKey = (res: any) => ({
  type: actionTypes.UPDATE_SEARCHKEY,
  payload: res,
});

export const onSetSearchText = (searchText: string) => ({
  type: actionTypes.SET_SEARCH_TEXT,
  payload: searchText
});

export const onSetChecked = (checked: any) => ({
  type: actionTypes.SET_CHECKED,
  payload: checked
});

export const onSetSelected = (selected: any) => ({
  type: actionTypes.SET_SELECTED,
  payload: selected
});

export const onSetUserDropdown = (isUserDropdown: boolean) => ({
  type: actionTypes.SET_USER_DROPDOWN,
  payload: isUserDropdown
});

export const updateMergeButtonStatus = (res: any) => ({
  type: actionTypes.UPDATE_MERGE_BUTTON_STATUS,
  payload: res,
});

export const getCreatorList = (res: any) => ({
  type: actionTypes.GET_CRETOR_LIST,
  payload: res,
});

export const experiencesReload = () => ({
  type: actionTypes.EXPERIENCES_RELOAD,
});

export const updateExperiencesTotal = (res: any) => ({
  type: actionTypes.UPDATE_TOTAL_EXPERIENCE_COUNT,
  payload: res,
});

export const updateSearchSessionPage = (page: number) => ({
  type: actionTypes.UPDATE_SEARCH_SESSION_PAGE,
  payload: page
});

export const updatePage = (page: number) => ({
  type: actionTypes.UPDATE_PAGE,
  payload: page
});
export const updateReelsPage = (reels_page: number) => ({
  type: actionTypes.UPDATE_REELS_PAGE,
  payload: reels_page
});

export const sortColumnFilterValue = (res:any) => ({
  type : actionTypes.SORT_COLUMN_FILTER_VALUE,
  payload:res
});

export const sortProjectColumnFilterValue = (res:any) => ({
  type : actionTypes.SORT_PROJECT_COLUMN_FILTER_VALUE,
  payload:res
});

export const sortReelsColumnFilterValue = (res:any) => ({
  type : actionTypes.SORT_REELS_COLUMN_FILTER_VALUE,
  payload:res
});

export const updateSearchClipPage = (clipPage: number) => ({
  type: actionTypes.UPDATE_SEARCH_CLIP_PAGE,
  payload: clipPage
});

export const deleteExperieceFromSession = (res: any) => ({
  type: actionTypes.DELETE_EXPERIENCE_FROM_SESSION,
  payload: res,
});

export const renameExperieceFromSession = (res: any) => ({
  type: actionTypes.REBNAME_EXPERIENCE_FROM_SESSION,
  payload: res,
});

// fail notificaion
const notificationFail = (err: any, errormessage: any) => {
  let msg = Messages.NOTIFICATIONS.ERROR.someThingWrong;
  if (errormessage) {
    msg = errormessage
  }
  if (err.graphQLErrors && err.graphQLErrors.length > 0) {
    msg = err.graphQLErrors[0].message;
  } else if (err.message) {
    msg = err.message;
  }
  store.addNotification({
    title: "Error!",
    message: <p>{ReactHtmlParser(msg)}</p>,
    type: "danger",
    insert: "bottom",
    container: "bottom-center",
    animationIn: ["animate__animated", "animate__fadeIn"],
    animationOut: ["animate__animated", "animate__fadeOut"],
    dismiss: {
      duration: 3000,
      onScreen: true
    }
  });
  return {
    type: actionTypes.ADD_NEW_NOTIFICATION_FAIL,
    state: msg
  }
};

// success notification
const notificationSuccess = (message: any) => {
  if (message) {
    store.addNotification({
      title: "Success!",
      message: message,
      type: "success",
      insert: "bottom",
      container: "bottom-center",
      animationIn: ["animate__animated", "animate__fadeIn"],
      animationOut: ["animate__animated", "animate__fadeOut"],
      dismiss: {
        duration: 3000,
        onScreen: true
      }
    })
  }
  return {
    type: actionTypes.ADD_NEW_NOTIFICATION_SUCCESS,
    state: message
  }
};

//get project experience list
export const getProjectExperiences = (experience: any, req: any, cb: any) => {
  return (dispatch: any) => {
    dispatch(setLoading(true));
    experience.query({
      query: ImmersionGQL.queryProjectExperiences,
      fetchPolicy: "no-cache",
      variables: { 
        project_id: req.project_id,
        sort_direction: req.sort_direction,
        sort_column: req.sort_column,
       }
    })
      .then(async (response: any) => {
        if (response.data.getProjectExperiences === null) {
          await dispatch(projectExperienceListSuccess(null, req.user_id));
        } else if (response.data.getProjectExperiences) {
          response.data.getProjectExperiences.firstpage = true;
          await dispatch(projectExperienceListSuccess(response.data.getProjectExperiences, req.user_id));
        }
        dispatch(setLoading(false));

        if (cb !== null)
          cb(true);
      })
      .catch(() => {
        dispatch(projectExperienceListSuccess([], req.user_id));
        dispatch(setLoading(false));

        if (cb !== null)
          cb(false);
      })
  }
};

//get experience list
export const getExperiences = (experience: any, req: any, cb: any) => {
  return (dispatch: any) => {
    dispatch(setLoading(true));
    experience.query({
      query: ImmersionGQL.queryListExperiences,
      fetchPolicy: "no-cache",
      variables: { 
        user_id: req.user_id?.toString(),
        page_no: req.page_no ? req.page_no : 1,
        size: req.size ? req.size : 20,
        sort_direction: req.sort_direction,
        sort_column: req.sort_column,
        session_ids: req.session_ids
       }
    })
      .then(async (response: any) => {
        if (response.data.listExperiences) {
          if (req.reels_sessions) {
            let firstpage = false;
            if (req.firstpage) {
              firstpage = true
            }
            response.data.listExperiences.firstpage = firstpage; 
            await dispatch(reelsSessionsListSuccess(response.data.listExperiences, req.user_id));
          } else {
            let firstpage = false;
            if(req.firstpage) {
              firstpage = true
            }
            response.data.listExperiences.firstpage = firstpage;
            await dispatch(experienceListSuccess(response.data.listExperiences, req.user_id));
          }
        }
        dispatch(setLoading(false));

        if (cb !== null)
          cb(true);
      })
      .catch(()=>{
        dispatch(reelsSessionsListSuccess([], req.user_id));
        dispatch(experienceListSuccess([], req.user_id));
        dispatch(setLoading(false));

        if (cb !== null)
          cb(false);
      })
  }
};

//check experiences stimulus statuses
export const checkStimulusStatus = (experience: any, req: any, cb: any) => {
  return (dispatch: any) => {
    // dispatch(setLoading(true));
    experience.query({
      query: ImmersionGQL.queryCheckStimulusStatus,
      fetchPolicy: "no-cache",
      variables: { 
        session_data: req.session_data
       }
    })
    .then(async (response: any) => {
      if (response.data) {
        await dispatch(checkStimulusStatusSuccess(response.data.checkStimulusStatus.sessions, req.user_id));
      }
      // dispatch(setLoading(false));

      if (cb !== null)
        cb(true);
    })
    .catch(() => {
      dispatch(reelsSessionsListSuccess([], req.user_id));
      dispatch(experienceListSuccess([], req.user_id));
      dispatch(setLoading(false));

      if (cb !== null)
        cb(false);
    })
  }
};

// create new experience
export const createExperience = (experience: any, req: any, callback: any) => {
  return (dispatch: any) => {
    dispatch(setLoading(true));
    const variables = {
      disable_fingerpulse: req.disable_fingerpulse,
      description: req.description,
      scheduled_end: req.scheduled_end,
      scheduled_start: req.scheduled_start,
      title: req.title,
      user_id: req.user_id,
      agenda_json: req.agenda_json,
      status: req.status,
      type: req.type,
      session_code: req.session_code,
      subcategory: req.subcategory,
      category: req.category,
      participants: req.participants,
      enable_controls: req.enable_controls,
      enable_watermark: req.enable_watermark,
      surveylink: req.surveylink,
      braintrust_id: req.braintrust_id ? req.braintrust_id : null,
      braintrust_demo: req.braintrust_demo ? req.braintrust_demo : false,
      hubs: req.hubs ? req.hubs : [],
      duplicate_experience_id: req.duplicateExperience ? req.duplicateExperience : null,
      using_hub_connectivity: req.using_hub_connectivity ? req.using_hub_connectivity : false,
      session_origin:req.session_origin ? req.session_origin : null
    };

    experience.mutate({
      mutation: ImmersionGQL.mutationCreateExperience,
      fetchPolicy: "no-cache",
      variables
    }).then((res: any) => {
      if (res.data.createExperience && res.data.createExperience.status === "true") {
        dispatch(experienceAddSuccess(variables));
        dispatch(setLoading(false));
        callback(res);
      } else {
        dispatch(setLoading(false));
        callback(null);
      }
    }).catch(() => {
      dispatch(setLoading(false));
      callback(null);
    })
  }
};

export const editExperience = (experience: any, req: any, cb: any) => {
  return (dispatch: any) => {
    const variables = req.survey_link
      ? {
        description: req.description,
        scheduled_end: req.scheduled_end,
        scheduled_start: req.scheduled_start,
        title: req.title,
        user_id: req.user_id,
        session_id: req.session_id,
        survey_link: req.survey_link
      }
      : {
      description: req.description,
      scheduled_end: req.scheduled_end,
      scheduled_start: req.scheduled_start,
      title: req.title,
      user_id: req.user_id,
      session_id: req.session_id
    };
    experience.mutate({
      mutation: ImmersionGQL.mutationEditExperience,
      fetchPolicy: "no-cache",
      variables
    })
      .then((response: any) => {
        if(response.data.editExperience.status === "true") {
          dispatch(experienceEditSuccess(variables));
          cb('success');
        } else {
          dispatch(notificationFail({}, response.data.editExperience.message));
          cb(null);
        }
      }).catch((error: any) => {
        dispatch(notificationFail(error, error.message));
        cb(null);
      })
  }
};

//cancel experience
export const cancelExperience = (experience: any, req: any) => {
  return (dispatch: any) => {
    const variables = {
      user_id: req.user_id,
      session_id: req.session_id
    };
    experience.mutate({
      mutation: ImmersionGQL.mutationCancelExperience,
      fetchPolicy: "no-cache",
      variables
    })
      .then(() => {
        dispatch(notificationSuccess(Messages.NOTIFICATIONS.SUCCESS.CANCELEXPERIENCE));
        dispatch(experienceCancelSuccess(variables));
      }).catch((error: any) => {
        dispatch(notificationFail(error, error.message))
      })
  }
};

//delete multi experiences
export const deleteExperiences = (experience: any, req: any, cb: any) => {
  return (dispatch: any) => {
    const variables = {
      session_code: req.session_code
    };
    experience.mutate({
      mutation: ImmersionGQL.mutationDeleteExperiences,
      fetchPolicy: "no-cache",
      variables
    })
      .then((res:any) => {
        if(res && res.data && res.data.deleteExperiences && res.data.deleteExperiences.messagecode){
          dispatch(notificationSuccess(Messages.NOTIFICATIONS.SUCCESS.DELETEEXPERIENCE))
          cb(dispatch(deleteExperieceFromSession(req.session_code)));
        }
      }).catch(() => {
        localStorage.removeItem("deleteExpId");
        cb(null);
      })
  }
};

//rename experience
export const renameExperience = (experience: any, req: any, cb: any) => {
  return (dispatch: any) => {
    const variables = {
      session_title: req.session_title,
      session_id: req.session_id.toString()
    };
    experience.mutate({
      mutation: ImmersionGQL.mutationRenameExperience,
      fetchPolicy: "no-cache",
      variables
    })
      .then(() => {
        dispatch(notificationSuccess(Messages.NOTIFICATIONS.SUCCESS.EDITEXPERIENCE));
        cb(dispatch(renameExperieceFromSession(variables)));
      }).catch(() => {
        cb(null);
      })
  }
};

//add experience to project folder
export const addProjectToExperience = (experience: any, req: any, cb: any) => {
  return (dispatch: any) => {
    const variables = {...req};
    dispatch(setLoading(true));
    experience.mutate({
      mutation: ImmersionGQL.mutationAddProjectToExperience,
      fetchPolicy: "no-cache",
      variables
    }).then((res: any) => {
      if (res.data['addProjectToExperience']) {
        dispatch(addProjectToExperienceSuccess(res.data['addProjectToExperience']));
        cb(dispatch(experiencesReload()));
      }
      // dispatch(setLoading(false));
    }).catch(() => {
      // handle error
      // dispatch(setLoading(false))
      cb(null);
    })
  }
};

// remove  Experiences from project folder
export const removeExperienceFromProject = (client: any, req: any, cb: any) => {
  return (dispatch: any) => {
    const variables = {...req};
    dispatch(setLoading(true));
    client.mutate({
      mutation: ImmersionGQL.mutationRemoveExperienceFromProject,
      fetchPolicy: "no-cache",
      variables
    }).then((res: any) => {
      if (res.data['removeExperienceFromProject']) {
        dispatch(addProjectToExperienceSuccess(res.data['removeExperienceFromProject']));
        cb(dispatch(experiencesReload()));
      }
    }).catch(() => {
      cb(null);
    })
  }
};

// search experience
export const searchExperience = (experience: any, req: any) => {
  return (dispatch: any) => {
    dispatch(setLoading(true));
    dispatch(setSearchLoading(true));
    experience.query({
      query: ImmersionGQL.querySearch,
      fetchPolicy: "no-cache",
      variables: { ...req }
    })
      .then((response: any) => {
        if (response.data) {
          dispatch(updateSearchKey(response.data.search));
        } else {
          dispatch(updateSearchKey(null));
        }
        dispatch(setLoading(false));
        dispatch(setSearchLoading(false));
      })
      .catch(() => {
        dispatch(updateSearchKey(null));
        dispatch(setLoading(false));
        dispatch(setSearchLoading(false));
      })
  }
};

//get creator users
export const getCreatorsList = (client: any,) => {
  return (dispatch: any) => {
    // dispatch(setLoading(true));
    client.query({
      query: ImmersionGQL.querygetCreatorsList,
      fetchPolicy: "no-cache",
      // variables: { keyword: req.keyword }
    })
      .then((response: any) => {
        if (response.data) {
          dispatch(getCreatorList(response.data.getCreatorsList));
        }else{
          dispatch(getCreatorList(null));
        }
        // dispatch(setLoading(false));
      })
      .catch(()=>{
        // dispatch(updateSearchKey(null));
        // dispatch(setLoading(false));
      })
  }
};

// experience count
export const getExperiencesTotal = (client: any, request: any) => {
  return (dispatch: any) => {    
    client.query({
      query: ImmersionGQL.queryGetExperiencesTotal,
      fetchPolicy: "no-cache",
      variables: { user_id: request.user_id }
    })
    .then((response: any) => {
      if (response.data.getExperiencesTotal && response.data.getExperiencesTotal.status === 'true') {
        if (response.data.getExperiencesTotal.data) {
          dispatch(updateExperiencesTotal(response.data.getExperiencesTotal.data.count));
        }
      }
    })
    .catch(() => {

    })
  }
};

export const getListExperiencesReels = (experience:any, req:any) => {
  return (dispatch: any) => {
    dispatch(setLoading(true));
    experience.query({
      query: ImmersionGQL.queryGetListExperiancesReels,
      fetchPolicy: "no-cache",
      variables: { 
        user_id: req.user_id?.toString(),
        page_no: req.page_no ? req.page_no : 1,
        size: req.size ? req.size : 20,
        sort_direction: req.sort_direction,
        sort_column: req.sort_column,
       }
    })
    .then(async (response: any) => {
      if (response.data.listExperiencesReels) {
        let firstpage = false;
        if(req.firstpage) {
          firstpage = true
        }
        response.data.listExperiencesReels.firstpage = firstpage; 
        await dispatch(listExperienceReelsSuccess(response.data.listExperiencesReels, req.user_id));
      }
      dispatch(setLoading(false));
    })
    .catch(() => {
      dispatch(listExperienceReelsSuccess([], req.user_id));
      dispatch(setLoading(false));
    })
  }
};

export const getReelSessions = (experience:any, req:any) => {
  return (dispatch: any) => {
    dispatch(setLoading(true));
    experience.query({
      query: ImmersionGQL.queryGetReelSessions,
      fetchPolicy: "no-cache",
      variables: { 
        session_code: req.session_code,
      }
    })
    .then(async (response: any) => {
      if (response.data.ReelsSession) {
        await dispatch(reelSessionsList(response.data.ReelsSession));
      }
      dispatch(setLoading(false));
    })
    .catch(() => {
      dispatch(listExperienceReelsSuccess([], req.user_id));
      dispatch(setLoading(false));
    })
  }
};

//create new reel experience
export const createReelExperience = (experience: any, req: any, cb: any) => {
  return (dispatch: any) => {
    dispatch(setLoading(true));
    const variables = {
      sessions: req.sessions,
      reel_sessions: req.reel_sessions,
      project_id: req.project_id,
      description: req.description,
      scheduled_end: req.scheduled_end,
      scheduled_start: req.scheduled_start,
      title: req.title,
      user_id: req.user_id,
      agenda_json: req.agenda_json,
      status: req.status,
      type: req.type,
      session_code: req.session_code,
      subcategory: req.subcategory,
      category: req.category,
      participants: req.participants,
      enable_controls:req.enable_controls,
      enable_watermark:req.enable_watermark,
      surveylink: req.surveylink
    };
    experience.mutate({
      mutation: ImmersionGQL.mutationcreateReelsExperience,
      fetchPolicy: "no-cache",
      variables
    })
      .then((res: any) => {
        if (res?.data?.createReelsExperience?.status === "true") {
          dispatch(reelsAddSuccess(variables));
          cb(res);
        }else{
          dispatch(setLoading(false));
        }
      }).catch((error: any) => {
        dispatch(notificationFail(error, error.message));
        dispatch(setLoading(false));
      })
  }
};

// remove  Experiences from project folder
export const mergeClip = (client: any, req: any, cb: any) => {
  return (dispatch: any) => {
    const variables = {...req};
    dispatch(setLoading(true));
    client.mutate({
      mutation: ImmersionGQL.mutationmergeClip,
      fetchPolicy: "no-cache",
      variables
    }).then((res: any) => {
      if (res.data['mergeClip']) {
        dispatch(mergeClipsSuccess(res.data['mergeClip']));
        cb(dispatch(experiencesReload()));
      }
      // dispatch(setLoading(false));
    }).catch(() => {
      // handle error
      // dispatch(setLoading(false));
      cb(null);
    })
  }
};

const addRemoveBenchmarkSuccess = (session_id: any, saved_benchmark: boolean) => ({
  type: actionTypes.ADD_REMOVE_BENCHMARK_SUCCESS,
  payload: {
    session_id,
    saved_benchmark
  }
});

export const onAddRemoveBenchmarkExperience = (client: any, request: any, callback?: any) => {
  return (dispatch: any) => {
    const { session_id, star } = request;
    const req = {
      department_id: request.department_id,
      star: request.star,
      user_id: request.user_id,
      sessions: request.sessions
    };
    client.mutate({
      mutation: ImmersionGQL.mutationAddRemoveStarExperience,
      fetchPolicy: "no-cache",
      variables: { ...req }
    }).then((res: any) => {
      if (res.data.addremoveStarExperience && res.data.addremoveStarExperience.status === 'true') {
        callback ? callback(res.data.addremoveStarExperience) : dispatch(addRemoveBenchmarkSuccess(session_id, star));
      } else {
        callback ? callback(null) : dispatch(setBenchmarkLoading(false));
      }
    }).catch(() => {
      callback ? callback(null) : dispatch(setBenchmarkLoading(false));
    })
  }
};

export const onCloseBanner = (client: any, request: any, callback: any) => {
  return () => {
    client.query({
      query: ImmersionGQL.closeBanner,
      fetchPolicy: "no-cache",
      variables: { ...request }
    }).then( (res: any) => {
      if (res.data.closeBanner && res.data.closeBanner.status === 'true') {
        callback(res.data.closeBanner)
      } else {
        callback(null);
      }
    }).catch(() => {
      callback(null)
    })
  }
};